import { Component, Prop, PropSync, VModel, Vue } from 'vue-property-decorator';
import { Category } from '@/models/Category';
import { FastProductVariant } from '@/models/FastProductVariant';

@Component<ProductVariantAutocomplete>({})
export default class ProductVariantAutocomplete extends Vue {
  //#region @VModel

  @VModel()
  protected internalValue!: boolean;

  //#endregion

  //#region @PropSyncs
  //#endregion

  //#region @Props

  @Prop({ default: 'Create a product / Select a product' })
  protected label!: string;

  @Prop({ default: 'Select your choise' })
  protected placeholder!: string;

  protected items: Item[] = [
    {
      id: true,
      name: 'Create a product',
    },
    {
      id: false,
      name: 'Select a product',
    },
  ];

  //#endregion

  //#region Handlers
  //#endregion

  //#region Helpers
  //#endregion
}

interface Item {
  id: boolean;
  name: string;
}
